module.exports = __webpack_public_path__ + "static/media/06.aaa7e8df.png";